import type { LocalSettings } from "@app/config/LocalSettings";
import localSettings from "@app/config/LocalSettings";
import type Integration from "@app/types/integrations/Integration";

class IntegrationsSettings {
  settings: LocalSettings;

  // Integration id stashed while a re-authentication OAuth flow round-trips through the
  // external provider. sessionStorage keeps it tab-local so the callback page can tell a
  // re-authentication apart from a brand-new connection.
  private readonly REAUTH_INTEGRATION_ID = "__REAUTH_INTEGRATION_ID__";

  constructor(settings: LocalSettings) {
    this.settings = settings;
  }

  getReauthIntegrationId = (): Integration["id"] | undefined => {
    const integrationId = parseInt(sessionStorage.getItem(this.REAUTH_INTEGRATION_ID) ?? "", 10);
    return Number.isInteger(integrationId) && integrationId > 0 ? integrationId : undefined;
  };

  resetReauthIntegrationId = () => {
    sessionStorage.removeItem(this.REAUTH_INTEGRATION_ID);
  };

  setReauthIntegrationId = (integrationId: Integration["id"]) => {
    sessionStorage.setItem(this.REAUTH_INTEGRATION_ID, String(integrationId));
  };
}

const integrationsSettings = new IntegrationsSettings(localSettings);
export default integrationsSettings;
